module.exports = __webpack_public_path__ + "img/ornamental-railing.9644719e.jpg";